import useCurrentLang from '@/hooks/useCurrentLang';
const en = {
  voiceExternalPending: 'AI Voice-to-Text is awaiting AIMT access approval. Production availability has not yet been verified.',
  readinessNotice: 'Some features are not yet available. Included allowances do not mean a feature has been activated. Please check which features are currently available before purchasing.',
  expiredPayment: 'This payment session has expired. Choose the product again to create a new payment.',
  applicationUnknown:
    'The original application is being checked. Do not submit another application; contact support if it remains unconfirmed.',
  manualConversion: 'Company-linked accounts require a manual review before conversion. Please contact eBRAM.',
  reviewPendingHint: 'Identity changes are pending review. General updates apply to your existing approved identity.',
  noEntitlement: 'No currently valid entitlement',
  included: 'Included allowance',
  source: 'Source',
  resume: 'Resume original payment',
  state: 'Status',
  serviceUnavailable: 'This service is not available yet.',
  notEligible:
    'This product is not available for your current account or plan. Review the eligibility requirements or contact eBRAM.',
  pricing: 'Pricing',
  standard: 'Standard Plan',
  legal: 'Legal Professional',
  lawTechFunding: 'Apply for LawTech Funding Scheme',
  lawTechFundingGuide: 'Application Guide for the DoJ Funding Scheme for LawTech Solution',
  lawTechFundingEnquire: 'Enquire Now',
  plans: 'Plans',
  free: 'Free',
  buy: 'Buy now',
  pay: 'Confirm and continue to payment',
  login: 'Sign in',
  register: 'Create account',
  back: 'Back to pricing',
  retry: 'Try again',
  loading: 'Loading…',
  unavailable: 'Purchasing is not available yet.',
  error: 'The request could not be confirmed. Please retry the same request; do not place a duplicate order.',
  price: 'Price',
  quantity: 'Quantity',
  unit: 'Unit',
  until: 'Valid until',
  from: 'Valid from',
  oneTime: 'One-time payment for 12 calendar months. No automatic renewal.',
  freePeriod: 'Free quantities reset every 12 months from account registration; unused credits do not carry forward.',
  account: 'Account',
  current: 'Current plan',
  subscriptionPage: 'Back to my subscription',
  next: 'Paid future periods',
  usage: 'Service allowances',
  available: 'Available',
  reserved: 'Reserved',
  debt: 'Outstanding usage',
  unlimited: 'Unlimited',
  sources: 'Allowance sources and expiry',
  transactions: 'Transactions',
  ownUsage: 'Your usage history',
  noRecords: 'No records',
  storage: 'Storage capacity',
  mainOnly: 'Only the main account can purchase. Contact your main account holder.',
  standalone: 'Individual services',
  topUp: 'Top-up rates',
  topUpRule:
    'Top-ups are available only to active new paid-plan members. They expire with the current plan and do not carry forward.',
  standaloneRule: 'Consumable packages are valid for 12 months from successful payment, independently of plan expiry.',
  contact: 'Contact eBRAM',
  planned: 'Planned — launch date to be announced',
  notOpen: 'Not yet available',
  periodPayment: '12 months from successful payment; the confirmed dates will appear after payment.',
  confirmation: 'Plan purchase confirmation',
  difference: 'Entitlement comparison',
  fullPrice: 'Original price',
  credit: 'Unused-value credit',
  due: 'Amount payable',
  acknowledgement:
    'I understand that the old plan’s included allowances will be replaced. Existing add-ons retain their original expiry dates; outstanding usage is deducted first.',
  acknowledge: 'Please confirm the allowance changes before continuing.',
  expiryChanged: 'The price or expiry changed. Please review the updated information before purchasing.',
  expired: 'Your selection expired. Please select the product again.',
  confirmed: 'Purchase confirmed.',
  pending: 'Payment is pending confirmation. Do not pay again.',
  reviewPayment: 'This payment requires a manual review. Please contact support and do not pay again.',
  pendingPurchase: 'You have a paid plan awaiting activation. Review your paid plans before starting another purchase.',
  pendingPayment:
    'An earlier payment is still unresolved. Open Transactions in your subscription and resume the original payment; do not place another order.',
  originalPurchaseRights: 'Original purchase rights',
  legacyRightsNotice:
    'Your Pro rights follow the original purchase record. An unspecified amount does not mean the service was excluded. Professional pre-purchases preserve them until their original expiry.',
  barrister: 'Barrister professional profile',
  businessInfo: 'Business Information',
  businessName: 'Business Name',
  englishName: 'English practising name',
  chineseName: 'Chinese name (optional)',
  jurisdiction: 'Jurisdiction of practice',
  address: 'Business contact address (private)',
  qualification: 'Qualification information or evidence (private)',
  chambers: 'Chambers (optional; separate from your business identity)',
  website: 'Website (optional)',
  areas: 'Practice areas (optional; separate with commas)',
  publicConsent: 'Confirm which approved professional information may be published',
  sameName: 'You may use your own practising name as the business name. Do not enter your chambers as your company.',
  required: 'This field is required.',
  reason: 'Reason for submission or correction',
  submit: 'Submit for review',
  saveGeneral: 'Save general information',
  approved: 'Approved',
  notSubmitted: 'Not submitted',
  pendingReview: 'Pending review',
  rejected: 'Not approved',
  needsInfo: 'More information required',
  approvalRule: 'You may pay first and provide this information later. Barrister qualification approval is required before plan activation.',
  oldMemberRule:
    'Existing paid periods remain available. Approval is required before your next new renewal or upgrade.',
  submitted: 'Submitted for review. Payment does not verify your professional identity.',
  memberSelection: 'Choose members who retain shared access',
  memberPause:
    'Your member count exceeds the current allowance. Shared functions are paused for subaccounts until the main account chooses the retained members. Accounts and files are preserved.',
  selectMembers: 'Save retained members',
  member: 'Member',
  seats: 'Subaccounts (excluding the main account)',
  applications: 'External service applications',
  subject: 'Certificate holder / business subject',
  subjectKind: 'Subject type',
  personal: 'Personal',
  business: 'Business',
  subjectConfirm:
    'I have checked the holder or business subject. Changes after submission to the provider require support.',
  apply: 'Apply using available entitlement',
  applicationRule:
    'Submitting reserves an entitlement. It is consumed when the provider accepts the application, even if it later fails. Issuance is subject to review; the certificate validity dates are separate from the application deadline.',
  createdApplication: 'Application recorded; provider acceptance has not yet been confirmed.',
  generalSaved: 'General information updated.',
  role: 'Account type',
  individual: 'Individual',
  company: 'Company',
  representative: 'I confirm that I am authorized to represent this company.',
  approvalNeeded: 'Barrister approval is required before plan activation. Review your professional information.',
  companyApprovalNeeded:
    'Company qualification is required before plan activation. Review your company information.',
  membershipResolutionNeeded:
    'Your current shared member settings are incompatible with this plan. Review member sharing before purchasing; contact eBRAM if you need assistance.',
  reviewMembers: 'Review member sharing',
  faq: 'FAQ',
};
const tc: Record<keyof typeof en, string> = {
  voiceExternalPending: 'AI 語音轉文字尚待 AIMT 外部開通，正式可用性尚未驗收。',
  readinessNotice: '部分功能尚未開放，包含額度不代表功能已啟用；購買前請確認目前開放項目。',
  expiredPayment: '此付款已確認逾期，請重新選擇商品，再建立新的付款。',
  applicationUnknown: '正在查核原申請，請勿重新提出另一筆申請；若持續無法確認，請聯絡支援。',
  manualConversion: '公司或關聯帳號須經人工核對後才能轉換，請聯絡 eBRAM。',
  reviewPendingHint: '重要身分變更仍待審核，一般資料更新會套用於目前已核准身分。',
  noEntitlement: '目前沒有有效權益',
  included: '方案內含',
  source: '來源',
  resume: '恢復原付款',
  state: '狀態',
  serviceUnavailable: '此服務目前尚未開放。',
  notEligible: '此商品不符合目前帳號或方案資格，請確認適用條件或聯絡 eBRAM。',
  pricing: '方案價格',
  standard: '標準方案',
  legal: '法律專業方案',
  lawTechFunding: '申請法律科技資助計劃',
  lawTechFundingGuide: '律政司法律科技方案資助計畫申請指引',
  lawTechFundingEnquire: '立即查詢',
  plans: '方案',
  free: '免費',
  buy: '立即購買',
  pay: '確認並前往付款',
  login: '登入',
  register: '建立帳號',
  back: '返回方案價格',
  retry: '重試',
  loading: '載入中…',
  unavailable: '目前尚未開放購買。',
  error: '暫時無法確認結果，請重試原請求，勿重複下單。',
  price: '價格',
  quantity: '份量',
  unit: '單位',
  until: '到期時間',
  from: '生效時間',
  oneTime: '單次付款取得 12 個曆月權益，不自動續扣。',
  freePeriod: '免費數量型額度以註冊日為起點每 12 個月重設，未用完不累積。',
  account: '帳號',
  current: '目前方案',
  subscriptionPage: '返回訂閱與方案',
  next: '已付款的未來期間',
  usage: '服務額度',
  available: '可用',
  reserved: '預留',
  debt: '欠額',
  unlimited: '不限量',
  sources: '額度來源與到期時間',
  transactions: '交易紀錄',
  ownUsage: '本人使用紀錄',
  noRecords: '目前沒有紀錄',
  storage: '儲存容量',
  mainOnly: '請由主帳號購買，或聯絡主帳號管理人。',
  standalone: '單項服務',
  topUp: 'Top-up 加購費率',
  topUpRule: '僅限有效新版付費方案會員購買；隨購買時目前方案到期，未用完不結轉。',
  standaloneRule: '消耗型單項包自付款成功起有效 12 個月，不受方案到期影響。',
  contact: '請聯絡 eBRAM',
  planned: '預計推出，實際時間另行公告',
  notOpen: '尚未開放',
  periodPayment: '自付款成功日起有效 12 個月，實際起訖時間將於付款確認後顯示。',
  confirmation: '方案購買確認',
  difference: '權益比較',
  fullPrice: '原價',
  credit: '未使用價值折抵',
  due: '應付金額',
  acknowledgement: '我了解原方案內含額度將由新方案額度取代，既有加購保留原到期日，欠額會先抵扣。',
  acknowledge: '請先確認額度變更，再前往付款。',
  expiryChanged: '價格或效期已變更，請重新確認資訊後購買。',
  expired: '商品選擇已過期，請重新選購。',
  confirmed: '購買已確認。',
  pending: '付款確認中，請勿再次付款。',
  reviewPayment: '此付款須人工確認，請聯絡支援，勿再次付款。',
  pendingPurchase: '你有已付款待啟用的方案，請先查看已付款方案，再進行其他購買。',
  pendingPayment: '已有一筆尚未確認的付款。請至訂閱明細的交易紀錄恢復原付款，勿重新下單。',
  originalPurchaseRights: '依原購買紀錄',
  legacyRightsNotice: '舊 Pro 權益請以原購買紀錄為準；左欄未列數量不代表未包含。專業方案預購會保留原權益至原到期日。',
  barrister: '大律師執業資料',
  businessInfo: '業務資料（Business Information）',
  businessName: '業務／執業名稱（Business Name）',
  englishName: '英文執業姓名',
  chineseName: '中文姓名（選填）',
  jurisdiction: '執業司法管轄區',
  address: '業務聯絡地址（私人資料）',
  qualification: '可供審核的資格資料或佐證（私人資料）',
  chambers: '所屬 chambers（選填，與本人業務身分分開）',
  website: '網站（選填）',
  areas: '執業領域（選填，以逗號分隔）',
  publicConsent: '請確認哪些經核准的專業資料可公開',
  sameName: '業務名稱可使用本人執業姓名；請勿將 chambers 當成本人的公司名稱。',
  required: '此欄位為必填。',
  reason: '送件或更正原因',
  submit: '送出審核',
  saveGeneral: '儲存一般資料',
  approved: '已核准',
  notSubmitted: '尚未送件',
  pendingReview: '審核中',
  rejected: '未通過',
  needsInfo: '待補件',
  approvalRule: '可先付款再補交執業資料，方案啟用前須通過大律師資格審核。',
  oldMemberRule: '既有已付款期間維持權益；下次新提交的續購或升級前須完成審核。',
  submitted: '資料已送審；付款不代表專業身分已驗證。',
  memberSelection: '選擇保留共用權益的成員',
  memberPause: '成員數超過目前額度。主帳號完成選擇前，子帳號暫停公司共用功能；帳號及文件均保留。',
  selectMembers: '儲存保留成員',
  member: '成員',
  seats: '子帳號（不含主帳號）',
  applications: '外部服務申請',
  subject: '證書持有人／申請事業主體',
  subjectKind: '申請主體類型',
  personal: '個人',
  business: '事業',
  subjectConfirm: '我已核對持有人或事業主體；送供應商後如需修改，須聯絡支援。',
  apply: '使用可用權益提出申請',
  applicationRule:
    '提交時先預留，供應商受理後即核銷，即使後續未成功也不自動退額。核發須審核；證書有效期與提出申請的期限分開計算。',
  createdApplication: '申請已記錄，尚未代表供應商已受理。',
  generalSaved: '一般資料已更新。',
  role: '帳號類型',
  individual: '個人',
  company: '公司',
  representative: '我確認具代表此公司的權限。',
  approvalNeeded: '方案啟用前須通過大律師資格審核，請查看執業資料。',
  companyApprovalNeeded: '方案啟用前須具有效公司資格，請查看公司資料。',
  membershipResolutionNeeded:
    '目前的子帳號共享設定與此方案不相容。請先確認成員共享安排，再繼續購買；如需協助，請聯絡 eBRAM。',
  reviewMembers: '檢視成員共享設定',
  faq: '常見問題',
};
const sc: Record<keyof typeof en, string> = {
  ...tc,
  lawTechFunding: '申请法律科技资助计划',
  lawTechFundingGuide: '律政司法律科技方案资助计划申请指引',
  lawTechFundingEnquire: '立即查询',
};
export const useDmpCopy = () => {
  const lang = useCurrentLang();
  return lang === 'en' ? en : lang === 'sc' ? sc : tc;
};
export const formatHKDate = (value: string | null | undefined, english = false): string => {
  if (!value) return '—';
  const iso = /Z$|[+-][0-9]{2}:[0-9]{2}$/.test(value) ? value : value.replace(' ', 'T') + 'Z';
  const d = new Date(iso);
  if (!Number.isFinite(d.getTime())) return '—';
  return (
    new Intl.DateTimeFormat(english ? 'en-HK' : 'zh-Hant-HK', {
      timeZone: 'Asia/Hong_Kong',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(d) + ' (HK)'
  );
};
export const formatHKMoney = (minor: number) =>
  'HK$ ' +
  new Intl.NumberFormat('en-HK', { minimumFractionDigits: minor % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(
    minor / 100
  );
export function paymentError(error: unknown, c: ReturnType<typeof useDmpCopy>): string {
  const code = (error as { response?: { data?: { message?: string } } })?.response?.data?.message;
  if (code === 'dmp_barrister_approval_required') return c.approvalNeeded;
  if (code === 'dmp_company_approval_required') return c.companyApprovalNeeded;
  if (code === 'dmp_membership_resolution_required') return c.membershipResolutionNeeded;
  if (code === 'dmp_main_account_required') return c.mainOnly;
  if (code === 'dmp_service_runtime_unavailable') return c.serviceUnavailable;
  if (code === 'dmp_purchase_in_progress') return c.pendingPayment;
  if (code === 'dmp_pending_purchase_required_review') return c.pendingPurchase;
  if (
    [
      'dmp_active_paid_plan_required',
      'dmp_storage_product_not_eligible',
      'dmp_purchase_not_eligible',
      'dmp_account_context_requires_review',
    ].includes(code || '')
  )
    return c.notEligible;
  if (
    [
      'dmp_upgrade_credit_manual_review',
      'dmp_pro_credit_manual_review',
      'dmp_prepaid_period_requires_manual_review',
      'dmp_reconciliation_required',
    ].includes(code || '')
  )
    return c.reviewPayment;
  if (['dmp_quote_expired', 'dmp_quote_changed'].includes(code || '')) return c.expiryChanged;
  if (
    [
      'dmp_v2_disabled',
      'dmp_v2_checkout_disabled',
      'dmp_external_workflow_not_ready',
      'dmp_provider_test_readiness_required',
      'dmp_v2_enforcement_disabled',
    ].includes(code || '')
  )
    return c.unavailable;
  return c.error;
}
